import { ApiError, postForm } from '../shared/api/client';
import { hide, show } from '../shared/ui/dom';

type AuthResponse = { success?: boolean; error?: string };

function showError(message: string): void {
  const errorEl = document.getElementById('auth-error');
  if (!errorEl) return;
  errorEl.textContent = message;
  (errorEl as HTMLElement).style.display = 'block';
  show(errorEl);
}

async function init(): Promise<void> {
  try {
    const response = await fetch('api/auth/me.php', {
      credentials: 'same-origin',
      cache: 'no-store'
    });
    if (response.ok) {
      window.location.href = './';
      return;
    }
  } catch {
    // Not logged in.
  }

  const form = document.getElementById('login-form') as HTMLFormElement | null;
  const btn = document.getElementById('login-btn') as HTMLButtonElement | null;
  const errorEl = document.getElementById('auth-error');
  if (!form || !btn || !errorEl) return;

  form.addEventListener('submit', async event => {
    event.preventDefault();
    hide(errorEl);
    btn.disabled = true;
    btn.textContent = 'Connexion…';

    try {
      const body = new FormData(form);
      const remember = document.getElementById('remember-me') as HTMLInputElement | null;
      body.set('remember_me', remember?.checked ? '1' : '0');

      const data = await postForm<AuthResponse>('api/auth/login.php', body);
      if (data.success) {
        window.location.href = './';
        return;
      }
      showError(data.error || 'Erreur de connexion');
    } catch (error) {
      if (error instanceof ApiError && error.status === 401) {
        showError('Email ou mot de passe incorrect');
      } else {
        showError(error instanceof Error ? error.message : 'Erreur réseau. Vérifiez que le serveur est démarré.');
      }
    } finally {
      btn.disabled = false;
      btn.textContent = 'Se connecter';
    }
  });
}

void init();
